export const QUERIES_KEYS = {
  SINGLE_EXAM: (examId: string | number) => ["exam", examId.toString()],
  SINGLE_SURVEY: (surveyId: string | number) => ["survey", surveyId.toString()],
  EMAIL_TRIGGERS: () => ["emailTriggers"],
  BLOCKED: (skip: number, limit: number, searchPhrase: string = "") => ["blocked", skip, limit, searchPhrase],
  CATEGORIES: ["categories"],
  CATEGORY_TREE: ["categoryTree"],
  CATEGORY_BY_ID: (categoryId: string | number) => ["categoryById", categoryId.toString()],
  CATEGORY_TERMS: (categoryId: string | number) => ["categoryTerms", categoryId.toString()],
  CATEGORY_FORM_GROUPS: (categoryId: string | number) => ["categoryFormGroups", categoryId.toString()],
  COURSE_BY_ID: (courseId: string | number) => ["courseById", courseId.toString()],
  COURSE_SCHEDULE_BY_ID: (courseScheduleId: string | number) => ["courseScheduleById", courseScheduleId.toString()],
  COURSE_EXAMS: (courseId: string | number) => ["courseExams", courseId.toString()],
  COURSE_EXAM_FETCH_WITH_STUDENTS: (courseId: string | number) => ["courseExamFetchWithStudents", courseId.toString()],
  COURSE_EXAM_BY_ID: (courseId: string | number, courseExamId: string | number) => [
    "courseExamById",
    courseId.toString(),
    courseExamId.toString(),
  ],
  COURSE_RATINGS: (courseId: string | number) => ["courseRatings", courseId.toString()],
  INTEGRATION_PRODUCT_BY_EXTERNAL_ID: (integrationId: string | number, externalId: string | number) => [
    "integrationProductByExternalId",
    integrationId.toString(),
    externalId.toString(),
  ],
  COURSE_FORMS: (courseId: string | number) => ["courseForms", courseId.toString()],
  COURSE_STATUS_BY_ID: (courseId: string | number) => ["courseStatusById", courseId.toString()],
  COURSE_FINANCES: (courseId: string | number) => ["courseFinances", courseId.toString()],
  TRAINER_COST_ENTRIES: (courseId: string | number) => ["trainerCostEntries", courseId.toString()],
  TRAINER_AVAILABILITY: (trainerId: string | number) => ["trainerAvailability", trainerId.toString()],
  TRAINER_AVAILABILITY_REQUESTS: (trainerId: string | number) => ["trainerAvailabilityRequests", trainerId.toString()],
  TRAINER_FILES: (trainerId: string | number) => ["trainerFiles", trainerId.toString()],
  TRAINER_FILE_COMMENTS: (trainerId: string | number, fileId: string | number) => [
    "trainerFileComments",
    trainerId.toString(),
    fileId.toString(),
  ],
  COURSE_FINANCES_BY_ID: (courseFinanceId: string | number) => ["courseFinancesById", courseFinanceId.toString()],
  COURSE_FINANCES_CATEGORIES: (skip: number, limit: number, searchPhrase: string, filter: string, orderBy: string) => [
    "courseFinancesCategories",
    skip,
    limit,
    searchPhrase,
    filter,
    orderBy,
  ],
  COURSE_FINANCES_BY_CATEGORIES: (courseId: string | number) => ["courseFinancesByCategories", courseId.toString()],
  COURSE_FINANCES_RECONCILIATION: (courseId: string | number) => ["courseFinancesReconciliation", courseId.toString()],
  COURSE_GROUPS: (skip: number, take: number, filter: string, orderBy: string) => [
    "courseGroups",
    skip,
    take,
    filter,
    orderBy,
  ],
  COURSE_GROUP_IMAGE_SIZES: () => ["courseGroupImageSizes"],
  COURSE_GROUP_SHOP_SETTINGS: () => ["courseGroupShopSettings"],
  COURSE_GROUP_WAITLIST: (courseGroupId: string | number) => ["courseGroupWaitlist", courseGroupId.toString()],
  COURSE_GROUP_BY_ID: (courseGroupId: string | number) => ["courseGroupById", courseGroupId.toString()],
  COURSE_GROUP_COURSES: (courseGroupId: string | number) => ["courseGroupCourses", courseGroupId.toString()],
  COURSE_GROUP_TRAINERS: (courseGroupId: string | number) => ["courseGroupTrainers", courseGroupId.toString()],
  COURSE_GROUP_RECIPIENTS: (courseGroupId: string | number | null) => [
    "courseGroupRecipients",
    courseGroupId?.toString(),
  ],
  COURSE_RECIPIENTS: (courseId: string | number | null) => ["courseRecipients", courseId?.toString()],
  COURSE_ALL_FORM_GROUPS: (isTemplate?: boolean) => ["courseAllFormGroups", isTemplate],

  COURSE_TERMS: (courseId: string | number) => ["courseTerms", courseId.toString()],
  COURSE_TRANCHES: (courseId: string | number) => ["courseTranches", courseId.toString()],
  COURSE_TRANCHES_PRICES: (courseId: string | number) => ["courseTranchesPrices", courseId.toString()],

  COURSES: (skip: number, limit: number, searchPhrase: string = "", filter: string = "", orderBy: string = "") => [
    "courses",
    skip,
    limit,
    searchPhrase,
    filter,
    orderBy,
  ],
  DICTIONARIES: (skip: number, limit: number, searchPhrase: string = "", filter: string = "", orderBy: string = "") => [
    "dictionaries",
    skip,
    limit,
    searchPhrase,
    filter,
    orderBy,
  ],
  DICTIONARY_VALUE_BY_ID: (dictionaryId: string | number) => ["dictionaryValueById", dictionaryId.toString()],
  DISCOUNTS: (skip: number, limit: number, searchPhrase: string = "", filter: string = "", orderBy: string = "") => [
    "discounts",
    skip,
    limit,
    searchPhrase,
    filter,
    orderBy,
  ],
  DISCOUNT_REGISTRATIONS: (discountId: string | number) => ["discountRegistrations", discountId.toString()],
  DISCOUNTS_BY_ID: (discountId: string | number) => ["discountsById", discountId.toString()],

  INVOICE_CONFIGURATION: (paymentId: string | number, courseId?: number) =>
    courseId
      ? ["invoiceConfiguration", paymentId.toString(), courseId.toString()]
      : ["invoiceConfiguration", paymentId.toString()],
  KSEF_XML: (paymentId: string | number, courseId?: number) =>
    courseId
      ? ["ksefXml", paymentId.toString(), courseId.toString()]
      : ["ksefXml", paymentId.toString()],
  DELAYED_PAYMENTS: (
    skip: number,
    limit: number,
    searchPhrase: string = "",
    filter: string = "",
    orderBy: string = "",
  ) => ["delayedPayments", skip, limit, searchPhrase, filter, orderBy],

  KSEF_INTEGRATIONS: () => ["ksef-integrations"],
  KSEF_INTEGRATION_BY_ID: (id: string | number) => ["ksef-integration", id.toString()],
  KSEF_DASHBOARD: () => ["ksef-dashboard"],
  KSEF_SUBMISSIONS: (id: string | number, skip: number, take: number, status?: number) => [
    "ksef-submissions",
    id.toString(),
    skip,
    take,
    status,
  ],
  KSEF_SUBMISSION_BY_ID: (id: string | number, submissionId: string | number) => [
    "ksef-submission",
    id.toString(),
    submissionId.toString(),
  ],
  KSEF_LOGS: (id: string | number, skip: number, take: number) => ["ksef-logs", id.toString(), skip, take],

  INTEGRATIONS: (skip: number, limit: number, searchPhrase: string = "", filter: string = "", orderBy: string = "") => [
    "integrations",
    skip,
    limit,
    searchPhrase,
    filter,
    orderBy,
  ],
  INTEGRATION_PRODUCTS: (
    integrationId: string | number,
    skip: number,
    limit: number,
    searchPhrase: string = "",
    filter: string = "",
    orderBy: string = "",
  ) => ["integrationProducts", integrationId.toString(), skip, limit, searchPhrase, filter, orderBy],
  INTEGRATION_PRODUCT_BY_ID: (integrationId: string | number, externalId: string | number) => [
    "integrationProductByExternalId",
    integrationId.toString(),
    externalId.toString(),
  ],
  INTEGRATION_CATEGORIES: (integrationId: string | number) => ["integrationCategories", integrationId.toString()],
  INTEGRATION_CATEGORIES_MAPPINGS: (integrationId: string | number) => [
    "integrationCategoriesMappings",
    integrationId.toString(),
  ],
  INTEGRATION_COURSE_GROUP_PRODUCTS: (integrationId: string | number, courseGroupId: string | number) => [
    "integrationCourseGroupProducts",
    integrationId.toString(),
    courseGroupId.toString(),
  ],
  INTEGRATION_BY_ID: (integrationId: string | number) => ["integrationById", integrationId.toString()],
  DOCUMENT_TEMPLATES: (
    skip: number,
    limit: number,
    searchPhrase: string = "",
    filter: string = "",
    orderBy: string = "",
  ) => ["documentTemplates", skip, limit, searchPhrase, filter, orderBy],
  // "Dokumenty 2.0" templates: the ROOT key is the prefix of every list, to invalidate them all at once.
  DOCUMENT_TEMPLATES_V2_ROOT: () => ["documentTemplatesV2"],
  DOCUMENT_TEMPLATES_V2: (search: string = "") => ["documentTemplatesV2", search],
  DOCUMENT_TEMPLATE_V2: (templateId: string | number) => ["documentTemplateV2", templateId.toString()],

  SCHEDULE_EVENTS: (courseId: string | number) => ["scheduleEvents", courseId.toString()],
  DOCUMENT_TYPES: (
    skip: number,
    limit: number,
    searchPhrase: string = "",
    filter: string = "",
    orderBy: string = "",
  ) => ["documentTypes", skip, limit, searchPhrase, filter, orderBy],
  ISSUES: (filter: string) => ["issues", filter],
  COURSE_RESOURCES: (courseId: string | number) => ["courseResources", courseId.toString()],
  COURSE_RESOURCE_TAB: (courseId: string | number, courseResourceTabId: string | number) => [
    "courseResourceTab",
    courseId.toString(),
    courseResourceTabId.toString(),
  ],
  COURSE_STUDENTS: (courseId: string | number) => ["courseStudents", courseId.toString()],
  COURSE_ATTENDANCE_DAYS: (courseId: string | number) => ["courseAttendanceDays", courseId.toString()],
  COURSE_ATTENDANCE: (courseId: string | number, day: string) => ["courseAttendance", courseId.toString(), day],
  COURSE_STUDENTS_DOCUMENTS: (courseId: string | number) => ["courseStudentsDocuments", courseId.toString()],
  COURSE_DOCUMENTS: (courseId: string | number) => ["courseDocuments", courseId.toString()],
  COURSE_DOCUMENT_STUDENTS: (courseId: string | number, templateId: string | number, studentsIds?: number[]) => [
    "courseDocumentStudents",
    courseId.toString(),
    templateId.toString(),
    studentsIds?.join(",") || "all",
  ],
  COURSE_STUDENT_END_SURVEY: (courseId: string | number, userId: string | number) => [
    "courseStudentEndSurvey",
    courseId.toString(),
    userId.toString(),
  ],

  EMAIL_TEMPLATE: (emailTemplateId: string | number) => ["emailTemplate", emailTemplateId.toString()],
  LOGS: ["logs"],
  STUDENT_PAYMENT_DISCOUNTS: (studentId: string | number) => ["studentPaymentDiscounts", studentId.toString()],

  PAYMENTS: (skip: number, limit: number, searchPhrase: string = "", filter: string = "", orderBy: string = "") => [
    "payments",
    skip,
    limit,
    searchPhrase,
    filter,
    orderBy,
  ],
  PLACES: (skip: number, limit: number, searchPhrase: string = "", filter: string = "", orderBy: string = "") => [
    "places",
    skip,
    limit,
    searchPhrase,
    filter,
    orderBy,
  ],
  PLACE_TAGS: (skip: number, limit: number, searchPhrase: string = "", filter: string = "", orderBy: string = "") => [
    "placeTags",
    skip,
    limit,
    searchPhrase,
    filter,
    orderBy,
  ],
  REPORTS: {
    COURSES_FINANCIAL: () => ["reports", "coursesFinancial"],
    COURSES_GROUP_FINANCIAL: () => ["reports", "coursesGroupFinancial"],
    SURVEYS_COURSES: () => ["reports", "surveysCourses"],
    SURVEYS_COURSE: (courseId: number) => ["reports", "surveysCourses", courseId],
    USER_REGISTRATIONS: () => ["reports", "userRegistrations"],
    COURSE_REGISTRATIONS_BY_COURSE: () => ["reports", "courseRegistrationsByCourse"],
    PLACE_COURSES_REPORT: () => ["reports", "placeCoursesReport"],
  },
  SURVEY: (surveyId: string | number) => ["survey", surveyId.toString()],
  SURVEYS: (skip: number, limit: number, searchPhrase: string = "", filter: string = "", orderBy: string = "") => [
    "surveys",
    skip,
    limit,
    searchPhrase,
    filter,
    orderBy,
  ],
  EMAILS: (skip: number, limit: number, searchPhrase: string = "", filter: string = "", orderBy: string = "") => [
    "emails",
    skip,
    limit,
    searchPhrase,
    filter,
    orderBy,
  ],
  EMAIL: (id: number) => ["email", id],
  SCHEDULED_EMAILS: (
    skip: number,
    limit: number,
    searchPhrase: string = "",
    filter: string = "",
    orderBy: string = "",
  ) => ["scheduled-emails", skip, limit, searchPhrase, filter, orderBy],
  SCHEDULED_EMAIL: (id: number) => ["scheduled-email", id],
  SCHEDULED_EMAIL_RECIPIENTS: (id: number) => ["scheduled-email-recipients", id],
  EMAIL_TEMPLATES: (
    skip: number,
    limit: number,
    searchPhrase: string = "",
    filter: string = "",
    orderBy: string = "",
  ) => ["emailTemplates", skip, limit, searchPhrase, filter, orderBy],

  EMAIL_PARAMETERS: (skip: number, limit: number, searchPhrase: string = "") => [
    "emailParameters",
    skip,
    limit,
    searchPhrase,
  ],

  EXAMS: (skip: number, limit: number, filter: string = "", orderBy: string = "") => [
    "exams",
    skip,
    limit,
    filter,
    orderBy,
  ],
  NOTIFICATIONS: (skip: number, limit: number, filter?: string) => ["notifications", skip, limit, filter],
  NOTIFICATIONS_UNREAD_COUNT: (category?: number[]) => ["notifications", "unread-count", category],
  INVITED_STUDENTS: () => ["invitedStudents"],
  STUDENT_COURSES: (studentId: string | number) => ["studentCourses", studentId.toString()],
  TOPIC_APPEARANCES: (topicId: string | number) => ["topicAppearances", topicId.toString()],
  TOPIC_GROUPS: (skip: number, limit: number, searchPhrase: string = "", filter: string = "", orderBy: string = "") => [
    "topicGroups",
    skip,
    limit,
    searchPhrase,
    filter,
    orderBy,
  ],
  TOPIC_GROUP_APPEARANCES: (topicGroupId: string | number) => ["topicGroupAppearances", topicGroupId.toString()],
  TOPIC_DETAILS: (topicId: string | number) => ["topicDetails", topicId.toString()],
  TOPIC_GROUP_DETAILS: (topicGroupId: string | number) => ["topicGroupDetails", topicGroupId.toString()],
  TOPICS: (skip: number, limit: number, searchPhrase: string = "", filter: string = "", orderBy: string = "") => [
    "topics",
    skip,
    limit,
    searchPhrase,
    filter,
    orderBy,
  ],

  TRAINERS: (searchPhrase = "", groups?: string[]) => ["trainers", searchPhrase, groups],
  TRAINERS_LIST: (
    skip: number,
    limit: number,
    searchPhrase: string = "",
    filter: string = "",
    orderBy: string = "",
  ) => ["trainersList", skip, limit, searchPhrase, filter, orderBy],

  TRAINER_LECTURE_CONFIRMATIONS: (
    skip: number,
    take: number,
    trainerId?: number,
    courseId?: number,
    dateFrom?: string,
    dateTo?: string,
    status?: string,
  ) => ["trainerLectureConfirmations", skip, take, trainerId, courseId, dateFrom, dateTo, status],

  TRAINER_GROUPS: (
    skip: number,
    limit: number,
    searchPhrase: string = "",
    filter: string = "",
    orderBy: string = "",
  ) => ["trainerGroups", skip, limit, searchPhrase, filter, orderBy],

  USERS: (skip: number, limit: number, filter: string = "", orderBy: string = "") => [
    "users",
    skip,
    limit,
    filter,
    orderBy,
  ],

  USER_PAYMENTS: (userId: string | number, courseId?: string | number) => [
    "userPayments",
    userId.toString(),
    courseId?.toString(),
  ],

  USER_EXAM: (
    courseId: string | number,
    courseExamId: string | number,
    userId: string | number,
    userExamId: string | number,
  ) => ["userExam", courseId.toString(), courseExamId.toString(), userId.toString(), userExamId.toString()],
  USER_SURVEYS: (skip: number, take: number, searchPhrase: string, filter: string, orderBy: string) => [
    "userSurveys",
    skip,
    take,
    searchPhrase,
    filter,
    orderBy,
  ],
  USER_SURVEY_BY_ID: (id: number) => ["userSurvey", id],
  SHOP: () => ["shop"],
  FOOTER_SETTINGS: () => ["footerSettings"],
  GOOGLE_ANALYTICS_CONFIG: () => ["googleAnalyticsConfig"],
  META_PIXEL_CONFIG: () => ["metaPixelConfig"],
  NEWSLETTER_SUBSCRIPTIONS: () => ["newsletterSubscriptions"],
  CONTACT_FORM_SETTINGS: () => ["contactFormSettings"],
  CONTACT_FORM_SUBMISSIONS: () => ["contactFormSubmissions"],
  BUTTON_STYLES: () => ["buttonStyles"],
  HEADING_STYLES: () => ["headingStyles"],
  MENU_CONFIG: () => ["menuConfig"],
  PRODUCT_CARD_SETTINGS: () => ["productCardSettings"],
  COURSE_DETAIL_PAGE_CONFIG: () => ["courseDetailPageConfig"],
  BREADCRUMB_SETTINGS: () => ["breadcrumbSettings"],
  ARCHIVED_COURSE_PAGE_SETTINGS: () => ["archivedCoursePageSettings"],
  SEO_SETTINGS: () => ["seoSettings"],
  LANDING_PAGES: (skip: number, limit: number, searchPhrase: string = "") => [
    "landingPages",
    skip,
    limit,
    searchPhrase,
  ],
  LANDING_PAGE_BY_ID: (id: string | number) => ["landingPageById", id.toString()],
  BLOG_POSTS: (skip: number, limit: number, searchPhrase: string = "") => [
    "blogPosts",
    skip,
    limit,
    searchPhrase,
  ],
  BLOG_POST_BY_ID: (id: string | number) => ["blogPostById", id.toString()],
  BLOG_CATEGORIES: () => ["blogCategories"],
  BLOG_AUTHORS: () => ["blogAuthors"],
  BLOG_SETTINGS: () => ["blogSettings"],
  SHOP_REDIRECTS: () => ["shopRedirects"],
  SHOP_REDIRECT_CHAINS: () => ["shopRedirectChains"],
  STATIC_FILES: () => ["staticFiles"],
  COURSEGROUP_ATTRIBUTES: (
    skip: number,
    limit: number,
    searchPhrase: string = "",
    orderBy: string = "",
  ) => ["coursegroupAttributes", skip, limit, searchPhrase, orderBy],
  COURSEGROUP_ATTRIBUTE_BY_ID: (id: string | number) => ["coursegroupAttributeById", id.toString()],
  COURSEGROUP_ATTRIBUTE_VALUES: (courseGroupId: string | number) => [
    "coursegroupAttributeValues",
    courseGroupId.toString(),
  ],
  COURSEGROUP_ATTRIBUTES_ALL: () => ["coursegroupAttributesAll"],
};
